// extracted by mini-css-extract-plugin
export default {"button":"button_button__+Vyjy","outlined":"button_outlined__tJqA1","button-light":"button_button-light__yBmJp"};